import React from 'react'

interface SuggestionsProps {
  isSelected?: boolean
}

export const SuggestionsIcon: React.FC<SuggestionsProps> = ({ isSelected = false }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 16.3327C2.5 16.7747 2.67559 17.1986 2.98816 17.5112C3.30072 17.8238 3.72464 17.9993 4.16667 17.9993C4.60869 17.9993 5.03262 17.8238 5.34518 17.5112C5.65774 17.1986 5.83333 16.7747 5.83333 16.3327C5.83333 15.8907 5.65774 15.4667 5.34518 15.1542C5.03262 14.8416 4.60869 14.666 4.16667 14.666C3.72464 14.666 3.30072 14.8416 2.98816 15.1542C2.67559 15.4667 2.5 15.8907 2.5 16.3327Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M15.8327 6.33333C16.2747 6.33333 16.6986 6.15774 17.0112 5.84518C17.3238 5.53262 17.4993 5.10869 17.4993 4.66667C17.4993 4.22464 17.3238 3.80072 17.0112 3.48816C16.6986 3.17559 16.2747 3 15.8327 3C15.3907 3 14.9667 3.17559 14.6542 3.48816C14.3416 3.80072 14.166 4.22464 14.166 4.66667C14.166 5.10869 14.3416 5.53262 14.6542 5.84518C14.9667 6.15774 15.3907 6.33333 15.8327 6.33333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M9.16602 16.3327H13.7493C14.5229 16.3327 15.2648 16.0254 15.8117 15.4784C16.3587 14.9314 16.666 14.1896 16.666 13.416C16.666 12.6425 16.3587 11.9006 15.8117 11.3536C15.2648 10.8066 14.5229 10.4993 13.7493 10.4993H7.08268C6.30913 10.4993 5.56727 10.1921 5.02029 9.64508C4.47331 9.0981 4.16602 8.35623 4.16602 7.58268C4.16602 6.80913 4.47331 6.06727 5.02029 5.52029C5.56727 4.97331 6.30913 4.66602 7.08268 4.66602H10.8327"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>
  )
}

export default SuggestionsIcon
